var _global = (typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {}); _global.SENTRY_RELEASE={id:"f9c28ca50af7bc8fda32ea795f3f96c1b488a5f3"};
      _global.SENTRY_RELEASES=_global.SENTRY_RELEASES || {};
      _global.SENTRY_RELEASES["front__cleaning-management-system@atinn"]={id:"f9c28ca50af7bc8fda32ea795f3f96c1b488a5f3"};
      